import React from "react";
import styles from "./IconArrowFilled.module.css";

export default function IconArrowFilled() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.0296 14.6087L7.42417 11.2174C6.98506 10.8043 6.88706 10.3317 7.1302 9.79957C7.3724 9.26652 7.80551 9 8.42952 9H15.5709C16.1949 9 16.6281 9.26652 16.8703 9.79957C17.1134 10.3317 17.0154 10.8043 16.5763 11.2174L12.9709 14.6087C12.8322 14.7391 12.682 14.837 12.5202 14.9022C12.3585 14.9674 12.1851 15 12.0002 15C11.8153 15 11.642 14.9674 11.4802 14.9022C11.3184 14.837 11.1682 14.7391 11.0296 14.6087Z"
                fill="var(--static-text-strong)"/>
        </svg>
    );
}

export const IconArrowFilledLeft = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.arrowFilledLeft}>
            <path
                d="M11.0296 14.6087L7.42417 11.2174C6.98506 10.8043 6.88706 10.3317 7.1302 9.79957C7.3724 9.26652 7.80551 9 8.42952 9H15.5709C16.1949 9 16.6281 9.26652 16.8703 9.79957C17.1134 10.3317 17.0154 10.8043 16.5763 11.2174L12.9709 14.6087C12.8322 14.7391 12.682 14.837 12.5202 14.9022C12.3585 14.9674 12.1851 15 12.0002 15C11.8153 15 11.642 14.9674 11.4802 14.9022C11.3184 14.837 11.1682 14.7391 11.0296 14.6087Z"
                fill="var(--static-text-strong)"/>
        </svg>
    );
}

export const IconArrowFilledRight = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.arrowFilledRight}>
            <path
                d="M11.0296 14.6087L7.42417 11.2174C6.98506 10.8043 6.88706 10.3317 7.1302 9.79957C7.3724 9.26652 7.80551 9 8.42952 9H15.5709C16.1949 9 16.6281 9.26652 16.8703 9.79957C17.1134 10.3317 17.0154 10.8043 16.5763 11.2174L12.9709 14.6087C12.8322 14.7391 12.682 14.837 12.5202 14.9022C12.3585 14.9674 12.1851 15 12.0002 15C11.8153 15 11.642 14.9674 11.4802 14.9022C11.3184 14.837 11.1682 14.7391 11.0296 14.6087Z"
                fill="var(--static-text-strong)"/>
        </svg>
    );
}

export const IconArrowFilledUp = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.arrowFilledUp}>
            <path
                d="M11.0296 14.6087L7.42417 11.2174C6.98506 10.8043 6.88706 10.3317 7.1302 9.79957C7.3724 9.26652 7.80551 9 8.42952 9H15.5709C16.1949 9 16.6281 9.26652 16.8703 9.79957C17.1134 10.3317 17.0154 10.8043 16.5763 11.2174L12.9709 14.6087C12.8322 14.7391 12.682 14.837 12.5202 14.9022C12.3585 14.9674 12.1851 15 12.0002 15C11.8153 15 11.642 14.9674 11.4802 14.9022C11.3184 14.837 11.1682 14.7391 11.0296 14.6087Z"
                fill="var(--static-text-strong)" />
        </svg>
    );
}